import React, { useState, useEffect, useRef} from 'react';
// import Recipe from '/src/scripts/recipe';
//import Recipe from './recipe';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar } from 'swiper/modules';
import 'swiper/css';           // core Swiper styles
import 'swiper/css/scrollbar'; // scrollbar module styles

import Recipe from './recipe';

import '../styles/layout/recipe-catalog.scss';
import axios from 'axios';

import magGlass from '../icons/magnifying-glass.svg';
import placeholder_img from '../images/placeholder-image.png';

import arrow from '/src/icons/arrow.svg';
import arrowRed from '/src/icons/arrow-red.svg';

const masthead =  document.querySelector('#masthead');
const root = document.querySelector('#render-react-recipe-catalog');
const feat_ids = root ? JSON.parse(root.getAttribute('featured_ids')) : null;
const background_image = root ?  root.getAttribute('background_image') : placeholder_img ;
const tax_filter_name = (root && root.getAttribute('tax_filter') != null) ? root.getAttribute('tax_filter') : false ;
const hero_title = (root && root.getAttribute('title') != null) ? root.getAttribute('title') : 'Easy Made Recipes' ;

function scrollTo (target){
    const elementTop = target.current.getBoundingClientRect().top;
    const offset = masthead.getBoundingClientRect().height;
    const targetPosition = elementTop - (offset/2);
    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
    });
}

const getRecipeCategoryTermId = async (slug) => {
    const taxonomy = "recipe-category";
    const apiUrl = `/wp-json/wp/v2/${taxonomy}?slug=${slug}`; // REST API endpoint

    try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
            throw new Error(`Error fetching terms: ${response.status}`);
        }
        const data = await response.json();
        console.log(data);
        if (data.length > 0) {
            return data[0].id;
        } else {
            throw new Error(`No term found with slug "${slug}"`);
        }
    } catch (error) {
        console.error("Error fetching recipe category term ID:", error);
        return null; // Return null in case of error
    }
};

const RecipeCatalog = () => {
    //console.log('RecipeCatalog');
    const catalogListRef = useRef(null);
    // const [q_ids, setQIDs] = useState([]);
    const [open_state, setOpenState] = useState(true);
    const [url_params, setUrlParams] = useState(null);

    const [active_recipe, setActiveRecipe] = useState(null);
    const recipeRef = useRef(null);
    const wrapperRef = useRef(null);

    useEffect(() => {
        // Parse the URL search parameters
        const searchParams = new URLSearchParams(window.location.search);
        console.log('searchParams',searchParams);
        if(searchParams.size > 0){
            const paramsObject = {};
            // Iterate over all parameters and store them in the object
            for (const [key, value] of searchParams.entries()) {
              paramsObject[key] = value;
            }
            setUrlParams(paramsObject);
        }

    }, []);

    useEffect(()=>{
        if(url_params){
            setOpenState(false);
            scrollTo(catalogListRef);
            const queryString =
            url_params instanceof URLSearchParams
                ? url_params.toString()
                : new URLSearchParams(url_params).toString();
            const newUrl = `${window.location.pathname}?${queryString}`;
            window.history.replaceState(null, "", newUrl);
        } else {
            window.history.replaceState(null, "", window.location.pathname);
        }
    }, [url_params]);

    useEffect(()=>{
        const updateMinHeight = () => {
          console.log('updateMinHeight', recipeRef.current.offsetHeight);
          if (recipeRef.current) {
                const newHeight = recipeRef.current.offsetHeight;
                if(newHeight <= 100){
                    return;

                }
                wrapperRef.current.style.height = newHeight+'px';
            }
          };
          
        const observer = new ResizeObserver(updateMinHeight);
          
        
        console.log('activepro',active_recipe,typeof active_recipe);
        if(active_recipe != null && recipeRef.current){
          window.history.replaceState({}, '', active_recipe.link);
          observer.observe(recipeRef.current);
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }

        if(active_recipe === null && wrapperRef.current) {
          window.history.replaceState({}, '', '/recipes');
          wrapperRef.current.style.height = '';
        //   updateUrlParams('type',activeCats.map(cats => cats.slug));
        }

        // Clean up the observer when the component unmounts
        return () => {

            if (recipeRef.current) {
              observer.unobserve(recipeRef.current);
            }
        };
    
      },[active_recipe])
    
    return (
        <div ref={wrapperRef} className="recipe-catalog__wrapper">
            <header style={{ backgroundImage : `url(${background_image})` }}>
                <h1>{hero_title}</h1>
                <Search params={url_params} setParams={setUrlParams} setOpenState={setOpenState}/>
            </header>
            <FeaturedRecipes feat_ids={feat_ids} open_state={open_state} setOpenState={setOpenState} setActiveRecipe={setActiveRecipe}/>
            <RecipeList url_params={url_params} setUrlParams={setUrlParams} catalogListRef={catalogListRef} setActiveRecipe={setActiveRecipe}/>
            <div ref={recipeRef} className={active_recipe ? "recipe-catalog__recipe-wrapper recipe-catalog__recipe-wrapper--active" : "recipe-catalog__recipe-wrapper"}>
                <div>
                    <Recipe inCatalog={true} recipe={active_recipe} setActiveRecipe={setActiveRecipe}/>
                </div>
            </div>
        </div>
    )

}

const Search = ({params, setParams, setOpenState}) =>{
    //console.log('Search');
    const inputRef = useRef(null);
    const [text,setText] = useState('');

    const handleSubmit = (e) => {
        console.log("handleSubmit");
        e.preventDefault();
        const inputValue = text;
        console.log('setQuery:', inputValue);
        setParams((prevParams) => {
            const newParams = prevParams ? { ...prevParams } : {};
            newParams.search = inputValue; // Safely set the "search" property
            return newParams; // Return the updated object
        });
        console.log('params',params);
        // setQuery(inputValue); // Get the value directly from the input element
    }

    return(
        <form className="recipe-catalog__search" name='recipe-search' onSubmit={(e) => handleSubmit(e)}>
            {/* <select onChange={(e) => setSearchOption(e.target.value)}>
            <option value=''>Keyword</option>
            {search_options.map((option,index) => 
                (
                <option key={index} value={option.id}>{option.name}</option>
                )
            )}
            </select> */}
            <input
                type="text"
                placeholder="Search..." 
                ref={inputRef}
                value={text}
                onChange={(e) => {
                    setText(e.target.value);
                    setOpenState(false);
                }}
            />
            <button 
                onClick={() => {
                    setText('');
                }}
                type='reset' 
                className={(text) ? 'close' : 'close close--hide'}
            >
                Clear form
            </button>
            <button type='submit'>
                <img src={magGlass} />
            </button>
        </form>
    )
}

const FeaturedRecipes = ({feat_ids,open_state, setOpenState,setActiveRecipe}) =>{
    //console.log('FeaturedRecipes');
    const [feat_recipes, setFeatRecipes] = useState([]);

    useEffect(() => {
        console.log('FeaturedRecipes[feat_ids]');
        const params = {
            _embed: true,
            per_page: 5,
            page:1,
            include: feat_ids,
            orderby:'include',
        }
        axios.get('/wp-json/wp/v2/recipe', { params: params })
          .then((response) => {
            const recipes = response.data;
            setFeatRecipes(recipes);
          })
          .catch((error) => {
            console.error('Error fetching recipe posts:', error);
        });
      }, [feat_ids]);

    const handleClick = (e,recipe) => {
        console.log('handlecli');
        e.preventDefault();  
        setActiveRecipe(recipe);
    }

    if(feat_ids === null){
        return ( null )
    }

    return(
        <section className={open_state ? "recipe-catalog__featured" : "recipe-catalog__featured recipe-catalog__featured--collapse"}>
            <h2>Featured Recipes</h2>
            <div className="feat-products__wrapper">
                {feat_recipes.map((recipe,index) => {
                    //index === 0 to see if it is the first one. if so, use full image                  
                    const image = (index === 0) ? 
                        recipe._embedded['wp:featuredmedia'][0].media_details.sizes.full 
                        : (recipe._embedded['wp:featuredmedia'][0].media_details.sizes['slider-thumbnail']) ? recipe._embedded['wp:featuredmedia'][0].media_details.sizes['slider-thumbnail'] : recipe._embedded['wp:featuredmedia'][0].media_details.sizes.full;
                    return (
                    <a 
                        key={index} 
                        aria-label="View recipe" 
                        href={recipe.link}
                        onClick={(e)=>{ handleClick(e, recipe); }}
                    >
                        <img 
                            src={(image) ? image.source_url : placeholder_img } 
                            width={(image) ? image.width : null} 
                            height={(image) ? image.height : null} 
                        />
                        <h3 dangerouslySetInnerHTML={{ __html:recipe.title.rendered }}></h3>
                        <RecipeRating recipe={recipe}/>
                        <p className="excerpt" dangerouslySetInnerHTML={{ __html:recipe.excerpt ? recipe.excerpt : recipe.content.rendered }}></p>
                    </a>
                    )
                })}
            </div>
            <button className="state" onClick={() => setOpenState((state) => !state)}>
                <span>{open_state ? 'Click to Collapse' : 'Click to Open'}</span>
                    <img src={open_state ? arrowRed : arrow} />
            </button>
        </section>
    )
}

const RecipeList = ({ url_params, setUrlParams, catalogListRef, setActiveRecipe }) =>{
    //console.log('RecipeList');
    const formRef = useRef(null);
    const galleryRef = useRef(null);
    const [recipes, setRecipes] = useState([]);
    const [total_page_number, setTotalPageNumber] = useState(1);
    const [tax_terms, setTaxTerms] = useState([]);
    const [params, setParams] = useState({
        _embed: true,
        per_page: 8,
        page:1,
        order:'asc',
        orderby: 'title'
    })

    const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' && window.innerWidth < 768);

    useEffect(() => {
        const fetchRecipes = async () => {
            console.log('RecipeList[params]', params, url_params);
    
            if (galleryRef.current) {
                galleryRef.current.classList.add('loading');
            }
    
            let u_params = { ...params };
    
            try {
                if (url_params?.search) {
                    console.log('searching', url_params);
                    u_params.search = url_params.search;
                } else if (url_params?.category) {
                    console.log('searching category', url_params);
                    const id = await getRecipeCategoryTermId(url_params.category); // Await works here
                    console.log('Category ID:', id);
                    if (id) {
                        u_params["recipe-category"] = id;
                    } else {
                        console.error('Category ID not found for:', url_params.category);
                    }
                } else if (url_params?.featured) {
                    console.log('searching featured', url_params);
                    const id = await getRecipeCategoryTermId(url_params.featured, 'featured-category'); // Await works here
                    console.log('Category ID:', id);
                    if (id) {
                        u_params["featured-category"] = id;
                    } else {
                        console.error('Category ID not found for:', url_params.featured);
                    }
                }
    
                const requestConfig = {
                    url: '/wp-json/wp/v2/recipe',
                    params: u_params,
                };
    
                console.log('Requesting URL:', axios.getUri(requestConfig));
    
                const response = await axios.get('/wp-json/wp/v2/recipe', { params: u_params });
                console.log("response ",response);
                const recipes = response.data;
                console.log("recipes from response",recipes);
                setTotalPageNumber(parseInt(response.headers['x-wp-totalpages'], 10));
                setRecipes(recipes);
    
                if (galleryRef.current) {
                    galleryRef.current.classList.remove('loading');
                }
            } catch (error) {
                console.error('Error fetching recipe posts:', error);
    
                if (galleryRef.current) {
                    galleryRef.current.classList.remove('loading');
                }
            }
        };
    
        fetchRecipes(); // Call the async function inside useEffect
    }, [params, url_params]);
    
    useEffect(()=>{
        const fetchTaxTerms = async() => {
            axios.get('/wp-json/wp/v2/recipe-category')
            .then((response) => {
                const terms = response.data;
                setTaxTerms(terms);
            })
            .catch((error) => {
                console.error('Error fetching recipe posts:', error);
            });
        }
        if(tax_filter_name){
            fetchTaxTerms();
        }

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
    },[])

    const handleFilter = (name, value) => {
        console.log('handleFilter',name, value);
        console.log('params',params);
        switch (name){
            case 'sortBy':
                switch (value){
                    case 'asc':
                        setParams((params) => ({...params, orderby: 'title', meta_key: null, page: 1 }));
                        break;
                    case 'views':
                        setParams((params) => ({...params, orderby: 'meta_value', meta_key: 'views', page: 1}));
                        break;
                    case 'rating':
                        setParams((params) => ({...params, orderby: 'meta_value', meta_key: 'rating', page: 1}));
                        break;
                }
                break;
            case 'perPage':
                setParams((params) => ({...params, per_page: value, page: 1}));
                break;
            case 'taxFilter':
                if(params?.[tax_filter_name] == value){
                    // Clear filter already set
                    setParams((params) => (
                        {
                        ...params, 
                        [tax_filter_name]: null,
                        page: 1
                        }
                    ));
                } else {
                    // else set filter
                    setParams((params) => (
                        {
                        ...params, 
                        [tax_filter_name]: value,
                        page: 1
                        }
                    ));
                }
                break;
            default:
                break;
            
        }
    }

    const handlePagination = (page) => {
        let num = (page === 0) ? 1 : page;
        num = (num > total_page_number) ? num - 1 : num;
        setParams((params) => ({...params, page: num, }));
    }

    const handleClick = (e,recipe) => {
        e.preventDefault();  
        setActiveRecipe(recipe);
      }

    let catalogTitle;
    if(url_params?.search){
        catalogTitle = `Search Results for '${url_params.search}'`;
    } else if (url_params?.category) {
        catalogTitle = `${url_params.category} Recipes`;
    } else {
        catalogTitle = 'All Recipes';
    }

    return(
        <section className="recipe-catalog__list" ref={catalogListRef}>
            <div className="list__top" ref={formRef}>
                <form name="sortBy" id='sortBy' onChange={(e) => handleFilter(e.target.name, e.target.value)}>
                    <label htmlFor='sortBy'>Sort By:</label>
                    <input type='radio' value='rating' name='sortBy' id='ratings'/>
                    <label className='radio' htmlFor='ratings'>Rating</label>
                    <input type='radio' value='views' name='sortBy' id='views'/>
                    <span>|</span>
                    <label className='radio' htmlFor='views'>Views</label>
                    <input type='radio' value='asc' name='sortBy' id='alphabetical'/>
                    <span>|</span>
                    <label className='radio' htmlFor='alphabetical'>A-Z</label>
                </form>
                <h2>
                    {catalogTitle}
                    {url_params && (
                        <button onClick={()=>{ setUrlParams(null) }}>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
                        </button>)
                    }
                </h2>
                <form name="perPage" id='perPage' onChange={(e) => handleFilter(e.target.name, e.target.value)}>
                    <label htmlFor='perPage'>Show:</label>
                    <input type='radio' value={8} name='perPage' id='eight'/>
                    <label className='radio' htmlFor='eight'>8</label>
                    <input type='radio' value={12} name='perPage' id='twelve'/>
                    <span>|</span>
                    <label className='radio' htmlFor='twelve'>12</label>
                    <input type='radio' value={24} name='perPage' id='all'/>
                    <span>|</span>
                    <label className='radio' htmlFor='all'>24</label>
                </form>

                {tax_terms.length > 0 && !isMobile && (

                <ul name="taxFilter">
                    {tax_terms.map(term => {
                        // console.log(term);
                        return (
                            <li
                                role='button'
                                id={term.id}
                                onClick={()=>{
                                    handleFilter('taxFilter', term.id);
                                }}
                                className={params?.[term.taxonomy] && params?.[term.taxonomy] == term.id ? 'active' : ''}
                            >{term.name}</li>
                        )
                    })}
                </ul>

                )}

                {tax_terms.length > 0 && isMobile && (

                <Swiper
                    spaceBetween={10}
                    slidesPerView={'auto'}
                    scrollbar={{
                        hide: true,
                    }}
                    modules={[Scrollbar]}
                    loop={false}
                    centeredSlides={false}
                    slideToClickedSlide={true}
                >
                {tax_terms.map((term) => (
                    <SwiperSlide 
                        key={term.id} 
                        onClick={()=>{
                            handleFilter('taxFilter', term.id);
                        }}
                        className={params?.[term.taxonomy] && params?.[term.taxonomy] == term.id ? 'active' : ''}
                    >{term.name}</SwiperSlide>
                ))}
                </Swiper>

                )}
            </div>
            <div className="list__gallery" ref={galleryRef}>
                {recipes.map((recipe,index) => {
                    const image = (recipe._embedded['wp:featuredmedia'][0].media_details.sizes['slider-thumbnail']) 
                                    ? recipe._embedded['wp:featuredmedia'][0].media_details.sizes['slider-thumbnail']
                                    : recipe._embedded['wp:featuredmedia'][0].media_details.sizes.full;
                    return (
                    <a key={index} 
                        aria-label="View recipe" 
                        onClick={(e) => handleClick(e,recipe)} 
                        href={recipe.link} 
                    >
                        <img 
                            src={(image) ? image.source_url : placeholder_img } 
                            width={(image) ? image.width : null} 
                            height={(image) ? image.height : null} 
                        />
                        <RecipeRating recipe={recipe} />
                        <h3 dangerouslySetInnerHTML={{ __html:recipe.title.rendered }}></h3>
                    </a>
                    )
                })}
            </div>
            <div className={total_page_number === 1 ? "list__bottom list__bottom--hide":"list__bottom"}>
                <button className="prev" onClick={()=>handlePagination(params.page - 1)}><img src={arrow} /></button>
                {[...Array(total_page_number)].map((_, index) => (
                    <button className={(params.page === index+1) ? "page page--active" : "page" } key={index} onClick={() => handlePagination(index + 1)}>{index + 1}</button>
                ))}
                <button className="next" onClick={()=>handlePagination(params.page + 1)}><img src={arrow} /></button>
            </div>
        </section>
    )
}

const RecipeRating = ({ recipe }) => {
    const rating = recipe?.acf?.rating || 0; // Make sure rating is defined
    const fullStars = Math.floor(rating);
    const fraction = rating - fullStars; // e.g., 0.5 for a 4.5 rating
  
    const totalStars = 5;
  
    return (
      <div className="reviews">
        {Array.from({ length: totalStars }).map((_, i) => {
          let fillPercent = 0; // default to empty star
          if (i < fullStars) {
            fillPercent = 100; // full star
          } else if (i === fullStars && fraction > 0) {
            fillPercent = fraction * 100; // partial star
          }
  
          const gradientId = `starGradient${i}`;
          
          return (
            <svg
              key={i}
              xmlns="http://www.w3.org/2000/svg"
              width="39.179"
              height="37.261"
              viewBox="0 0 39.179 37.261"
              style={{ marginRight: '2px' }}
            >
              <defs>
                <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style={{'stop-color': "var(--fill)"}} />
                  <stop offset={`${fillPercent}%`} style={{'stop-color': "var(--fill)"}} />
                  <stop offset={`${fillPercent}%`} style={{'stop-color': "var(--empty)"}} />
                  <stop offset="100%" style={{'stop-color': "var(--empty)"}} />
                </linearGradient>
              </defs>
              <path
                d="M19.589,0,13.535,12.266,0,14.233l9.8,9.547L7.482,37.261,19.589,30.9,31.7,37.261,29.384,23.78l9.795-9.547L25.642,12.266Z"
                fill={`url(#${gradientId})`}
                style={{'stroke': 'var(--fill)', 'stroke-width': '2px'}}
              />
            </svg>
          );
        })}

        <span>({(recipe?.acf?.number_of_reviews || '0' )})</span>
      </div>
    );
  }

export default RecipeCatalog;